export default __webpack_public_path__ + "static/media/blog04.7456c31c.png";